// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"275c7d3a","453":"72259910","677":"d492cdf6"}[chunkId] + ".chunk.js";
};